import { MarketsContainer } from '@/features/markets/MarketsContainer'

export function Markets() {
  return <MarketsContainer />
}
